import { isCard } from "@effektify/types";
const isCardConfig = (component) => typeof component === "object" && component !== null && isCard(component) && "type" in component && component.type === "card";
const isTemplateCard = (config) => "slots" in config && typeof config.slots === "object" && config.slots !== null && "variant" in config && typeof config.variant === "string";
const isChartTemplate = (component) => isCardConfig(component) && isTemplateCard(component) && ["graph-narrow", "graph-full", "graph-wide"].includes(component.variant);
const isSemiCircleCard = (component) => isChartTemplate(component) && component.slots.chart?.type === "semi-circle";
const isLineChartCard = (component) => isChartTemplate(component) && component.slots.chart?.type === "line_chart";
const isValueWithTrendTemplate = (component) => isCardConfig(component) && isTemplateCard(component) && ["value-with-trend", "value-single"].includes(component.variant);
const isTableTemplate = (component) => isCardConfig(component) && isTemplateCard(component) && ["table", "table-big", "table-half", "table-full", "table-6", "table-12"].includes(component.variant);
const isTextBlockTemplate = (component) => isCardConfig(component) && isTemplateCard(component) && ["text-block"].includes(component.variant);
const isBannerTemplate = (component) => isCardConfig(component) && isTemplateCard(component) && ["banner"].includes(component.variant);
export {
  isBannerTemplate,
  isChartTemplate,
  isLineChartCard,
  isSemiCircleCard,
  isTableTemplate,
  isTemplateCard,
  isTextBlockTemplate,
  isValueWithTrendTemplate
};
